module.exports = __webpack_public_path__ + "static/media/new-share2.af66ccdc.png";